export default __webpack_public_path__ + "static/media/warning.73cfa5f3.svg";